//import "bootstrap/dist/js/bootstrap.min.js";
import "react-bootstrap/dist/react-bootstrap.min.js";

import { Navigate, Route, Routes } from "react-router-dom";
import MyNavbar from "./components/MyNavbar";

import Home from "./pages/Home";
import Imprint from "./pages/Imprint";
import Info from "./pages/Info";
import Manual from "./pages/Manual";
import Post from "./pages/Post";
import Supporters from "./pages/Supporters";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
//import MyPoems from "./pages/MyPoems";
import Map from "./pages/Map";

/*
Look for additional parameters of the Link object, e. g. 'replace' to jump over login page,
or 'state={}' for state management
*/ 
function App() {

  return (
    <>
    <MyNavbar />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/info" element={<Info />} />
      <Route path="/manual" element={<Manual />} />
      <Route path="/anleitung" element={<Manual />} />
      <Route path="/post" element={<Post />} />
      <Route path="/imprint" element={<Imprint />} />
      <Route path="/supporters" element={<Supporters />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/login" element={<Login />} />
      <Route path="/map" element={<Map />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
    </>
  );
}

export default App;
